import { data_de_referencia_do_censo } from "./data-de-referencia-do-censo/routes";
import { marcacao_de_alunos } from "./marcacao-de-alunos/routes";
import { retrato_para_censo } from "./retrato-para-censo/routes";
import { migracao_do_censo_escolar } from "./migracao-do-censo-escolar/routes";
import { relatorio_de_acompanhamento_do_censo_escolar } from "./relatorio-de-acompanhamento-do-censo-escolar/routes";
import { codigo_inep } from "./codigo-inep/routes";
import { migracao_da_situacao_do_aluno } from "./migracao-da-situacao-do-aluno/routes";

const censo_escolar = [
  ...data_de_referencia_do_censo,
  ...marcacao_de_alunos,
  ...retrato_para_censo,
  ...migracao_do_censo_escolar,
  ...relatorio_de_acompanhamento_do_censo_escolar,
  ...codigo_inep,
  ...migracao_da_situacao_do_aluno,
];

export { censo_escolar };
